import React, { useEffect, useState } from "react";
import { PageHero } from "@/components/common/SectionHeading";
import { fetchFaqs } from "@/lib/lnlApi";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
    const [rows, setRows] = useState([]);
    const [cat, setCat] = useState("all");
    useEffect(() => { fetchFaqs().then(setRows); }, []);
    const cats = ["all", ...Array.from(new Set(rows.map((r) => r.category)))];
    const filtered = cat === "all" ? rows : rows.filter((r) => r.category === cat);
    return (
        <div data-testid="faq-page">
            <PageHero eyebrow="FAQ" title="Frequently asked questions" breadcrumbs={[{label:"Home",to:"/"},{label:"FAQ"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-3xl">
                    <div className="flex flex-wrap gap-2 mb-6">
                        {cats.map((c) => (
                            <button key={c} onClick={() => setCat(c)} className={`text-xs font-heading font-semibold rounded-full px-3 py-1.5 border ${cat === c ? "bg-lnl-green text-white border-lnl-green" : "bg-white border-lnl-border"}`} data-testid={`faq-cat-${c}`}>{c}</button>
                        ))}
                    </div>
                    <Accordion type="single" collapsible>
                        {filtered.map((r, i) => (
                            <AccordionItem key={r.id} value={`q-${i}`}>
                                <AccordionTrigger className="text-left" data-testid={`faq-q-${i}`}>{r.question}</AccordionTrigger>
                                <AccordionContent className="text-sm text-lnl-gray leading-relaxed">{r.answer}</AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </section>
        </div>
    );
}
